import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { HERO_IMAGE } from "@/data/content";

export const Hero = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden bg-[#faf6ef]"
    >
      {/* Background image, softly faded into cream */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_IMAGE}
          alt="UAE desert at golden hour"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-[#faf6ef]/55" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#faf6ef] via-[#faf6ef]/80 to-[#faf6ef]/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#faf6ef] via-transparent to-[#faf6ef]/60" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full pt-24">
        <div className="max-w-3xl">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="font-body-lux text-xs uppercase tracking-[0.35em] text-[#9c7d44] mb-8"
          >
            Travel Designer — Not a Package Seller
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="font-serif-lux font-light leading-[1.02] tracking-tight text-[#1f3a2e] text-5xl sm:text-6xl lg:text-7xl"
          >
            Your UAE Holiday
            <br />
            <span className="italic text-[#b8965a]">Designed Only</span> For You
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.25 }}
            className="font-body-lux text-base md:text-lg font-light text-[#47564d] mt-8 max-w-xl leading-relaxed"
          >
            We don&apos;t sell packages. We compose unforgettable UAE experiences
            around your interests, your budget and your travel style.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.4 }}
            className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-5"
          >
            <button
              data-testid="hero-book-btn"
              onClick={() => scrollTo("#contact")}
              className="font-body-lux text-sm tracking-wide bg-[#b8965a] text-[#fdfbf7] px-9 py-4 hover:bg-[#9c7d44] transition-colors duration-300"
            >
              Book a Consultation
            </button>
            <button
              data-testid="hero-explore-btn"
              onClick={() => scrollTo("#experiences")}
              className="nav-link font-body-lux text-sm tracking-wide text-[#1f3a2e]"
            >
              Explore Experiences
            </button>
          </motion.div>
        </div>
      </div>

      <motion.button
        data-testid="hero-scroll-indicator"
        onClick={() => scrollTo("#about")}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 text-[#9c7d44]"
        aria-label="Scroll down"
      >
        <motion.span
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
          className="block"
        >
          <ArrowDown size={22} strokeWidth={1.2} />
        </motion.span>
      </motion.button>
    </section>
  );
};
